// extracted by mini-css-extract-plugin
export default {"btn":"Network_btn__67z3d"};